module.exports = __webpack_public_path__ + "img/activity-luckdraw.7feb5fb0.png";